import { connect, MapStateToProps } from "react-redux";

import { getAttributeTypeByAttributeName, getConfigAttributeDisplayFormat, getRecordValueById } from "@multiweb/reactCore/datasource";
import { IAppState } from "@multiweb/types/react";
import { getInteractive } from "../../selectors";
import { FrameAttributeSharedProps } from "../../types";
import { FrameAttributeComponent, FrameAttributeComponentProps } from "../ListAttributeComponent";

type StateProps = Pick<FrameAttributeComponentProps, "displayFormat" | "type" | "interactive" | "value">;

const mapStateToProps: MapStateToProps<StateProps, FrameAttributeSharedProps, IAppState> = (
    state,
    { dataSourceKey, attributeName, recordId },
) => ({
    displayFormat: getConfigAttributeDisplayFormat(state, { dataSourceKey, attributeName }),
    type: getAttributeTypeByAttributeName(state, { dataSourceKey, attributeName }),
    interactive: getInteractive(state, dataSourceKey),
    value: getRecordValueById(state, { dataSourceKey, attributeName, recordId }),
});

export const ListAttribute = connect(mapStateToProps)(FrameAttributeComponent);
